import {fetchDashboardData, fetchReviewData, fetchClassData} from 'store/actions/dashboardActions'
import analytics from 'util/analytics';
import {SET_USER, SET_USER_LOADING} from 'store/reducers/userReducer'
export const resetApp = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch({ type: "RESET_APP"})
    }
}

export const loadDashboardForUserId = (userId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        firestore.collection("users").doc(userId)
            .get()
            .then(doc => {
                if (!doc.exists) {
                    // console.log('cant find user!');
                } else {
                    let user = doc.data();
                    // console.log("WE Got the user")
                    // console.log(user);
                    user.platformID = doc.id;
                    user.id = doc.id
                    if (user.isInstructor || user.platformID === 'ytnxDT1wRFnlzxoQyJKO') {
                        dispatch(fetchDashboardData(userId));
                        dispatch(fetchReviewData(userId));
                        dispatch(fetchClassData(userId));
                        dispatch({type: "SET_INSTRUCTOR", instructor: user});
                    }
                }
            })
            .catch( err => {
                console.log("error fetching user data: " + err)
            });
    };
}

export const loadAuthorizedApplication = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make async call to DB
        const firestore = getFirestore();
        dispatch({type: SET_USER_LOADING, loading: true})

        let userId = null
        if (userId) { 
            return firestore.collection("users").doc(userId).get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('cant find user!');
                    } else {
                        let user = doc.data()
                        user.id = userId
                        user.platformID = userId
                        dispatch({type: SET_USER, userData: user})
                        dispatch(loadDashboardForUserId(user.platformID))
                    }
                })
                .catch( err => {
                    console.log("error fetching user data: " + err)
                });
        } else {
            return firestore.collection("users").where("authID", "==", user.uid)
                .get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        console.log('cant find user!');
                    } else {
                        var users = [];
                        snapshot.forEach(function(doc) {
                            var data = doc.data();
                            data.platformID = doc.id;
                            users.push(data);
                        });
                        if (users[0]) {
                            const user = users[0];
                            console.log("GOT USER")
                            dispatch({type: SET_USER, userData: user})
                            dispatch(loadDashboardForUserId(user.platformID))
                            return user
                        }
                    }
                })
                .catch( err => {
                    console.log("error fetching user data: " + err)
                });

        }
    }
};